// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"218":"component---src-pages-404-tsx","536":"component---src-templates-blog-tsx","691":"component---src-pages-index-tsx"}[chunkId] || chunkId) + "-" + {"218":"e72887476c3d45995a90","536":"63bfbc365d96e1b18ac5","589":"e7ceb973cd8b476c81c5","691":"7f6e896d609337c92cd5"}[chunkId] + ".js";
};